export const helperUndo = (
  active: string,
  setante: any,
  anteHistory: string[],
  setanteHistory: any,
  setAAbonus: any,
  AAbonusHistory: string[],
  setAAbonusHistory: any,
) => {
  if (active === 'ante') {
    if (anteHistory.length <= 2) {
      setante('0')
      setanteHistory(['0'])
    } else {
      setante(anteHistory[anteHistory.length - 2])
      setanteHistory((h: any) => {
        h.length = h.length - 1
        return [...h]
      })
    }
  } else {

    if (AAbonusHistory.length <= 2) {
      setAAbonus('AA')
      setAAbonusHistory(['AA'])
    } else {
      setAAbonus(AAbonusHistory[AAbonusHistory.length - 2])
      setAAbonusHistory((h: any) => {
        h.length = h.length - 1
        return [...h]
      })
    }
  }
}
